<template>
    <v-app>
        <v-container class=" mt-8">
  <div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">

              <!--              <v-row v-if="statusBadge == 'pending'" class="d-flex justify-content-center mb-2">-->
              <!--                <p>وضعیت اطلاعات پروفایل شما: <span class="pending-status">در انتظار تایید</span></p>-->
              <!--              </v-row>-->
              <!--              <v-row v-else-if="statusBadge == 'accept'" class="d-flex justify-content-center mb-2">-->
              <!--                <p>وضعیت اطلاعات پروفایل شما: <span class="accept-status">تایید شده</span></p>-->
              <!--              </v-row>-->
              <!--              <v-row v-else-if="statusBadge == 'reject'" class="d-flex flex-column justify-content-center align-items-center mb-2">-->
              <!--                <p>وضعیت اطلاعات پروفایل شما: <span class="reject-status">رد شده</span></p>-->
              <!--                <p>جهت ویرایش اطلاعات پروفایل, روی این <router-link style="color: blue;" to="/company-register">لینک</router-link> کلیک کنید.</p>-->
              <!--              </v-row>-->
              <!--              <v-row v-else class="d-flex flex-column justify-content-center align-items-center mb-2">-->
              <!--                <p>وضعیت اطلاعات پروفایل شما: <span>اطلاعات خود را ثبت نکرده‌اید</span></p>-->
              <!--                <p>جهت ثبت اطلاعات پروفایل, روی این <router-link style="color: blue;" to="/company-register">لینک</router-link> کلیک کنید.</p>-->
              <!--              </v-row>-->
              <v-alert v-if="isPending" border="bottom" colored-border type="info" class="alert-warn mx-2 mt-4" elevation="2">
                تا زمانی که اطلاعات پروفایل شما تایید نشده باشد، قادر به ثبت بیلبورد جدید نمیباشید.
              </v-alert>
              <v-alert v-if="isRejected" border="bottom" colored-border type="error" class="alert-warn mx-2 mt-4" elevation="2">
                اطلاعات پروفایل شما توسط مدیریت رد شده است. لطفا اطلاعات خود را ویرایش نمایید.
              </v-alert>

              <v-card elevation="2" outlined>
                <v-card-title class="justify-content-between">

                  <!--                                    v-if="$can('transaction_create')"-->

                  <div>
                    <v-btn class="btn-add-with-text" @click="goto('billboard-register/create')" :disabled="!userValid" style="visibility: hidden">
                      <v-icon>mdi-plus</v-icon>
                      اضافه کردن
                    </v-btn>
                  </div>

                  <div>
                    <span>مدریت بیلبورد ها</span>
                  </div>


                  <div>
                    <v-btn class="btn-search" @click="tableProps = tablePropsDefault; getBillBoards()">
                      <v-icon>mdi-refresh</v-icon>
                      بارگذاری مجدد
                    </v-btn>
                  </div>


                </v-card-title>
                <v-divider />

                <div class="row">

                  <div class="col-md-12 p-5">
                    <data-table :data="userInfo" :columns="columns" :translate="translate" :per-page="[10, 25, 50, 100]"
                                @on-table-props-changed="reloadTable">
                      <div slot="filters" slot-scope="{ tableFilters, perPage }">
                        <div class="row mb-2">
                          <div class="col-md-4">
                            <select class="form-control pr-3" v-model="tableFilters.length">
                              <option :key="page" v-for="page in perPage">{{ page }}</option>
                            </select>
                          </div>
                          <div class="col-md-4">
                          </div>

                          <div class="col-md-4 ">
                            <v-text-field outlined dense label="جست و جو" class="pl-3"
                                          @change="(i) => (tableFilters.search = i)">

                            </v-text-field>
                          </div>
                        </div>
                      </div>

                    </data-table>
                  </div>
                </div>
              </v-card>

          <!--                      <Wallet  :dialog="dialog" v-model="dialog" :wallet="userWallet" />-->

        </div>
      </div>
    </div>
  </div>
        </v-container>
    </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import userManageButton from "@/view/pages/admin/users/userManageButton";
import loginRollback from "@/Utilities/LoginRollback";
import jwtService from "@/core/services/jwt.service";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import actionButton from '@/view/content/button'

export default {
  data() {
    return {
      selectedRows: [],
      dialog: false,
      userWallet: [],
      dialogInfo: null,

      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      url: 'billboard/admin',
      userInfo: {},
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'asc',
      },
      tablePropsDefault: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'asc',
      },
      columns: [
        {
          label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
          component: CheckboxFild,
          event: 'change',
          handler: this.change,
        },
        {
          label: 'ردیف',
          transform: (val) => {
            let row = this.userInfo.meta.current_page - 1;
            row = row * this.userInfo.meta.per_page;
            return row + val.row + 1;
          },
        },
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          colStyle: 'width: 100px;'
        },

        {
          label: 'نام کاربر',
          name: 'user.name',
          colStyle: 'width: 100px;'
        },
        {
          label: 'آدرس',
          name: 'address',
          orderable: true,
        },

        {
          label: 'مشخصات جغرافیایی',
          name: 'location',
          transform: (value, data) => {
            return value.data.location ? `${value.data.location[0]} , ${value.data.location[1]}` : 'ندارد'
          }
        },

        {
          label: 'دوره اجاره (روز)',
          name: 'rental_period',
          orderable: true,
          // transform: (value, data) => {
          //   return value.data.pack.title;
          // }
        },

        {
          label: 'موقعیت',
          name: 'type.place.name',
        },


        {
          label: 'نوع',
          name: 'type.name',
          orderable: true,

        },

        {
          label: 'وضعیت',
          name: 'status',
          orderable: true,
          transform: (value, data) => {
            return this.getStatusBadge(value.data.status)
          }
        },

        {
          label: 'عملیات',
          name: 'actions',
          component: actionButton,
          handler: this.actions,
          event: 'action',
          meta: {
            permission_prefix: 'user_',
            buttons: [
              {
                name : "edit",
                label : "ویرایش اطلاعات بیلبرد",
                icon : "pencil-alt",
                type:'edit',
                action: (a , b)=>{
                  // console.log(a.id)
                  this.goto(`billboard-list/${a.id}`)
                },
                permission : "billboard_own_update"
              },

              {
                name: "delete",
                label: "حذف بیلبرد",
                icon: "trash-alt",
                type: 'delete',
                action: (a, b) => { this.delBillBoard(a.id) },
                permission: "billboard_own_delete"
              }
            ]
          }
        },
      ],
      statusBadge: '',
      userValid: true,
      isRejected: false,
      isPending: false,
      userInfoGot : false
    }
  },
  created() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$route.meta.title }])
    this.getBillBoards(this.url)

    window.Vue.$on('selectAllListCheckBox', (e) => {
      this.selectAll(e.checked);
    })


  },

  methods: {
    async delBillBoard(id) {
      if (await this.$modal.yesNo(this.$t('CONFIRM.Delete'))) {
        this.$modal.showLoading();
        this.requestApiDelete('billboard/' + id)
            .then((a) => {
              this.$toast.success('با موفقیت حذف شد');
              this.getBillBoards();
            })
            .catch((e) => {
              this.$toast.error('خطا در حذف اتفاق افتاده است (با پشتیبانی تماس بگیرید)');
            }).finally((e) => {
          this.$modal.hideLoading();


        })
      }
    },


    getStatusBadge(status) {
      let text = status;
      let color = 'light'

      switch (status) {
        case "pending":
          text = 'در انتظار تایید';
          color = 'warning'
          break;

        case "active":
          text = 'فعال';
          color = 'success'
          break

        case "reject":
          text = 'رد شده';
          color = 'danger'
          break

        case "disable":
          text = 'مسدود';
          color = 'light'
          break
      }

      return `<span class="badge badge-${color}">${text}</span>`;
    },
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id)
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length)
        ]

      }
      window.document.querySelector("#select_all").checked = this.selectedRows.length == this.userInfo.data.length

    },

    filterOnlyCapsText(value, search, item) {
      return value != null &&
          search != null &&
          typeof value === 'string' &&
          value.toString().toLocaleUpperCase().indexOf(search) !== -1
    },

    getBillBoards(url = this.url, params = this.tableProps) {
      this.$modal.showLoading();
      this.requestApiGet(url, params).then(response => {
        this.userInfo = response.data;
      }).finally(() => {
        this.$modal.hideLoading();
        if (! this.userInfoGot){
          this.getUserInfo();
        }
      })
    },

    reloadTable(params) {
      this.getBillBoards(this.url, params)
    },

    actions(data, type) {
      this[type](data)
    },
    edit(data) {
      this.$router.push({ name: 'admin.user.edit', params: { id: data.id } })
    },
    information(data) {
      this.$router.push({ name: 'admin.users.information', params: { id: data.id } })
    },
    // wallet(data) {
    //   this.$router.push({name: 'admin.users.walletEdit', params: {id: data.id}})
    //
    //   // if (data.wallets.length > 0) {
    //   //   this.dialog = true;
    //   //   return this.userWallet = data;
    //   // }
    //   // this.$toast.warning('کیف پول کاربر در حال حاضر وجود ندارد')
    //   // this.$router.push({name: 'admin.users.wallet', params: {id: data.id}})
    // },
    checkout(data) {
      this.$modal.showLoading();
      this.getUserTokenWithId(data.id)
          .then((token) => {
            loginRollback.addLogin(this.getUser().name, jwtService.getToken())
            jwtService.saveToken(token)
            window.location.reload();
          }).catch((e) => {
        this.$toast.error("error")
      })
          .finally(() => {
            this.$modal.hideLoading();
          })
    },
  }
}

$('#select_all').click(function () {
  $('.checkBox').prop('checked', $(this).prop("checked"));
})
</script>
<style scoped>
.alert-warn {
  background-color: #CFD8DC;
}
.pending-status {
  background-color: rgb(224, 224, 94);
  padding: 0px 5px 0px 5px;
  font-weight: bold;
}
.accept-status {
  background-color: green;
  padding: 0px 5px 0px 5px;
  color: white;
  font-weight: bold;
}
.reject-status {
  background-color: red;
  padding: 0px 5px 0px 5px;
  color: white;
}
</style>
